exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ghost {\n  opacity: 0.8;\n  background: #c8ebfb;\n}\n.sortable-ghost {\n  background: #c8ebfb !important;\n}\n#myKanban {\n  width: max-content;\n}\n", ""]);

// exports
